import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "react-tooltip";
import { useTranslation } from "react-i18next";
import { ReactComponent as CheckIcon } from "images/profile/check-done.svg";
import {
  DTP_SERVICE_NAME,
  INTERPRETATION_SERVICE_NAME,
  LQE_REVIEW_SERVICE_NAME,
} from "utils/constantValues";

const RatesGroup = ({
  label,
  rates,
  key,
  serviceTitle,
  isCharacter = false,
  withCapacity = false,
  withRate = false,
}) => {
  const [t] = useTranslation();
  if (!rates || rates.length === 0) return null;

  return (
    <div
      className="flex w-full items-end content-end flex-wrap gap-x-6 gap-y-3"
      key={key}
    >
      <div className="flex w-full items-end content-end flex-wrap gap-x-6 gap-y-3">
        <div className="w-full flex-shrink-0 text-[#A0A0AB] font-semibold text-[16px] leading-[24px] font-['General_Sans']">
          {label}
        </div>
      </div>
      <div className="flex w-full items-end content-end flex-wrap gap-x-6 gap-y-3">
        {rates.map((rate, rateIndex) => (
          <div
            className={`grid gap-[2px] min-w-[300px] sm-max:w-full`}
            key={rateIndex}
          >
            <div className="flex items-center gap-2">
              <div className="text-[#51525C] font-medium text-[16px]">
                {serviceTitle === INTERPRETATION_SERVICE_NAME
                  ? t(`${serviceTitle}-rate-${rate.title}`)
                  : serviceTitle === DTP_SERVICE_NAME
                  ? t(`${rate.title} ${serviceTitle}`)
                  : t(`${rate.title} ${serviceTitle}`, {
                      isCharacter: isCharacter ? t("character") : t("word"),
                    })}
              </div>
              {rate.isVetted && (
                <>
                  <CheckIcon
                    data-tooltip-id={`vetted-${rate.serviceId}-${rateIndex}`}
                    className="w-5 h-5 text-green-600 cursor-pointer"
                  />
                  <Tooltip
                    className="bg-base-black rounded-[8px] opacity-[1]"
                    place="top"
                    id={`vetted-${rate.serviceId}-${rateIndex}`}
                    content={t("vetted")}
                  />
                </>
              )}
            </div>
            {withRate && (
              <div className="text-[#1D1B22] ">
                {withRate && withCapacity && (
                  <dov className="text-[#1D1B22] text-center font-['General_Sans'] text-[16px] font-semibold leading-[24px]">
                    {t("rate")}:
                  </dov>
                )}

                <span className="text-[#1D1B22] text-center font-['General_Sans'] text-[16px] font-semibold leading-[24px]">
                  {` $${rate.rate} `}
                </span>
                <span className="text-[#1D1B22] text-center font-['General_Sans'] text-[16px] font-semibold leading-[24px]">
                  {serviceTitle === INTERPRETATION_SERVICE_NAME
                    ? t(
                        `USD/${rate.title === "per word" ? "word" : rate.title}`
                      )
                    : rates.length > 1 &&
                      serviceTitle !== INTERPRETATION_SERVICE_NAME
                    ? `${t(`${rate.title}-${serviceTitle}`)}`
                    : serviceTitle === DTP_SERVICE_NAME
                    ? "USD/Slide"
                    : `USD/${t(rate.title, {
                        isCharacter: isCharacter ? t("character") : t("word"),
                      })}`}
                </span>
              </div>
            )}
            {withCapacity && (
              <div className="text-[#1D1B22] ">
                {withRate && withCapacity && (
                  <dov className="text-[#1D1B22] text-center font-['General_Sans'] text-[16px] font-semibold leading-[24px]">
                    {t("capacity")}:
                  </dov>
                )}
                <span className="text-[#1D1B22] text-center font-['General_Sans'] text-[16px] font-semibold leading-[24px]">
                  {` ${rate.capacity}`}
                </span>{" "}
                <span className="text-[#1D1B22] text-center font-['General_Sans'] text-[16px] font-semibold leading-[24px]">
                  {serviceTitle === INTERPRETATION_SERVICE_NAME
                    ? t(
                        `USD/${rate.title === "per word" ? "word" : rate.title}`
                      )
                    : serviceTitle === LQE_REVIEW_SERVICE_NAME
                    ? t("perHour")
                    : rates.length > 1 &&
                      serviceTitle !== INTERPRETATION_SERVICE_NAME
                    ? `${t(`char-${rate.title}`)} per ${t("day")}`
                    : serviceTitle === DTP_SERVICE_NAME
                    ? "Slide/Day"
                    : `USD/${t(rate.title, {
                        isCharacter: isCharacter ? t("character") : t("word"),
                      })}`}
                </span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RatesGroup;
RatesGroup.propTypes = {
  label: PropTypes.string,
  rate: PropTypes.object,
  key: PropTypes.string || PropTypes.number,
  serviceTitle: PropTypes.string,
  withCapacity: PropTypes.string,
  withRate: PropTypes.string,
};
